import CDSConfig from '../model/CDSConfig';
import CDSParser from '../parser/CDSParser';

export default class CDSLoader {

    loadCDSConfig(url) {

        let deferred = new $.Deferred();

        $.get(url)
            .done((data) => {
                let cdsParser = new CDSParser();
                let cdsConfig = cdsParser.parseCDSConfig(data);
                deferred.resolve(cdsConfig);
            })
            .fail(deferred.reject);

        return deferred;
    }

    loadCDSResponse(cdsConfig) {

        cdsConfig = (cdsConfig instanceof CDSConfig) ? cdsConfig : new CDSConfig();

        let url = cdsConfig.cdsUrl + '/coicds-list-valid-application-publications';

        let requestContent = '';
        if (cdsConfig.cdsUsername.length == 0 && cdsConfig.cdsPassword.length == 0) {
            requestContent = `<request applicationId="${cdsConfig.cdsLibraryId}"/>`;
        } else {
            requestContent = `<request applicationId="${cdsConfig.cdsLibraryId}" username="${cdsConfig.cdsUsername}" password="${cdsConfig.cdsPassword}"/>`;
        }

        let deferred = new $.Deferred();

        $.post(url, requestContent)
            .done((data) => {
                let cdsParser = new CDSParser();
                let cdsResponse = cdsParser.parseCDSResponse(data);
                deferred.resolve(cdsResponse);
            })
            .fail(deferred.reject);

        return deferred;
    }

}
